import React from 'react'

export default function Logo() {
  return (
    <div className="center-logo">
        <img src="./assets/images/logo.png" alt="logo" height={250} width={250} style={{ display: "none" }}/>
    </div>
  )
}
